import Vue from 'vue'
import Vuex from 'vuex'

import actions from '@/store/actions'
import getters from '@/store/getters'
import mutations from '@/store/mutations'
import state from '@/store/state.js'

import createpersistedstate from 'vuex-persistedstate'

Vue.use(Vuex)
const store =new Vuex.Store({
	actions,
	getters,
	mutations,
	state,
	plugins:[createpersistedstate({
		storage:window.sessionStorage
	})]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js